import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import CustomNotifications from '@/plugins/custom-notifications/CustomNotifications.plugin';
import i18n from './i18n';
import '@/styles/styles.scss';
// import directives
import './directives/ClickHold.directive';

// import polyfills
import 'intersection-observer';
import smoothscroll from 'smoothscroll-polyfill';

import FingerprintPlugin from '@/plugins/fingerprint/Fingerprint.plugin';
import FullscreenPlugin from '@/plugins/fullscreen/Fullscreen.plugin';
import { VueHammer } from 'vue2-hammer';

// kick off the polyfill!
smoothscroll.polyfill();

// configure vue
Vue.config.productionTip = false;

Vue.use(VueHammer);
Vue.use(CustomNotifications);
Vue.use(FingerprintPlugin);
Vue.use(FullscreenPlugin);

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app');
